import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import groupBy from 'lodash/groupBy'

export default class FilterButtons extends React.Component {
  static propTypes = {
    selectedCurrency: PropTypes.string,
    selectCurrency: PropTypes.func,
    markets: PropTypes.array
  }

  renderSecondaryCurrencies() {
    return <div className={styles.buttons} />
  }

  getOptions = () => {
    const currencyCodes = Object.keys(groupBy(this.props.markets, 'secondaryCurrency.code'))
    return [null].concat(currencyCodes)
  }
  renderOptions = () => {
    const {selectedCurrency} = this.props
    const options = this.getOptions()

    return options.map(opt => {
      const className = selectedCurrency === opt ? styles.selectedBtn : styles.btn
      return (
        <div key={opt} className={className} onClick={() => this.props.selectCurrency(opt)}>
          {opt || 'ALL'}
        </div>
      )
    })
  }

  render() {
    return <div className={styles.container}>{this.renderOptions()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/FilterBar/Mobile/FilterButtons/index.js